import { render, staticRenderFns } from "./GroupLayout.vue?vue&type=template&id=9ff3636e&scoped=true"
import script from "./GroupLayout.vue?vue&type=script&lang=js"
export * from "./GroupLayout.vue?vue&type=script&lang=js"
import style0 from "./GroupLayout.vue?vue&type=style&index=0&id=9ff3636e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ff3636e",
  null
  
)

export default component.exports